import React, { useState, useMemo, useRef, useEffect } from 'react';
import slotImg from '../assets/slot/slote.png';

const categories = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
// const symbols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; // can be numbers, emojis, or image paths

// const translateY = spinning ? -1000 : -(value * 80); // 80px per item

const getRandomItem = () => categories[Math.floor(Math.random() * categories.length)];

const goldGradient = 'linear-gradient(90deg, #b17e32 0%, #f3e681 60%, #cf9f41 100%)';
const goldBorder = '#b17e32';
const goldText = '#d49814';

const SLOT_BOX_SHADOW = `
  inset 0 8px 16px 0 rgba(0,0,0,0.45),
  inset 0 -8px 16px 0 rgba(0,0,0,0.45),
  0 4px 16px 0 rgba(209, 168, 54, 0.15),
  0 2px 8px 0 rgba(0,0,0,0.10) inset,
  0 1px 0 0 #fff8e1 inset
`;

const BUTTON_SHADOW = SLOT_BOX_SHADOW;

const REST_TILT = { x: 5, y: -3 };
const MAX_TILT = 10; // degrees

const BookSlotMachine = () => {
  const [slots, setSlots] = useState(['?', '?', '?']);
  const [spinning, setSpinning] = useState(false);
  const [hasSpun, setHasSpun] = useState(false);
  const [tilt, setTilt] = useState(REST_TILT);

  //new add
  // const reelRef = useRef();
  // const itemHeight = 128; // matches slot height
  // const totalItems = items.length;
  // const [offset, setOffset] = useState(0);

  // useEffect(() => {
  //   let frame;
  //   if (spinning) {
  //     let speed = 50; // pixels per frame
  //     const animate = () => {
  //       setOffset(prev => (prev + speed) % (itemHeight * totalItems));
  //       // slowly decrease speed
  //       speed = Math.max(5, speed * 0.97);
  //       frame = requestAnimationFrame(animate);
  //     };
  //     animate();
  //   } else {
  //     // Snap to stopIndex when finished
  //     const finalOffset = stopIndex * itemHeight;
  //     setOffset(finalOffset);
  //   }
  //   return () => cancelAnimationFrame(frame);
  // }, [spinning, stopIndex, totalItems]);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateY = ((offsetX - centerX) / centerX) * MAX_TILT;
    const rotateX = ((centerY - offsetY) / centerY) * MAX_TILT;
    setTilt({ x: rotateX, y: rotateY });
  };

  const handleMouseLeave = () => setTilt(REST_TILT);

  const handleButtonClick = () => {
    if (!spinning && !hasSpun) {
      setSpinning(true);
      const interval = setInterval(() => {
        setSlots([getRandomItem(), getRandomItem(), getRandomItem()]);
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
        setSlots([getRandomItem(), getRandomItem(), getRandomItem()]);
        setSpinning(false);
        setHasSpun(true);
      }, 1200);
    } else if (!spinning && hasSpun) {
      setSlots(['?', '?', '?']);
      setHasSpun(false);
    }
  };

  const getButtonLabel = () =>
    spinning ? 'SPINNING...' : hasSpun ? 'RESET' : 'PULL LEVER';

  // Memoized styles
  const tiltTransform = useMemo(
    () => `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
    [tilt]
  );

  return (
    <>
      <style>{`
        @keyframes glow {
          0% { box-shadow: 0 0 15px #f3e681, 0 0 30px #b17e32; }
          50% { box-shadow: 0 0 30px #f3e681, 0 0 60px #cf9f41; }
          100% { box-shadow: 0 0 15px #f3e681, 0 0 30px #b17e32; }
        }
      `}</style>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #000, #222 60%, #1a1a1a 100%)',
          perspective: '1000px',
        }}
      >
        <div
          // onMouseMove={handleMouseMove}
          // onMouseLeave={handleMouseLeave}
          style={{
            position: 'relative',
            borderRadius: 30,
            transformStyle: 'preserve-3d',
            transform: tiltTransform,
            outline: '10px dotted yellow',
            outlineOffset: -20,
            width: 340,
            height: 410,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: 'maroon',
            animation: 'glow 2s infinite alternate',
            transition: 'transform 0.2s ease-out',
          }}
        >
          <div
            style={{
              width: '100%',
              borderTopLeftRadius: 26,
              borderTopRightRadius: 26,
              padding: '1rem 0 3rem 0',
              background: 'maroon',
            }}
          />

          <img
            src={slotImg}
            alt="slot"
            style={{
              position: 'absolute',
              top: '-110px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '340px',
              height: '200px',
              objectFit: 'contain',
              zIndex: 2,
            }}
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0.5rem',
              padding: '1rem',
              borderRadius: '0.5rem',
              marginTop: '1rem',
              background: goldGradient,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '0.5rem',
                padding: '1rem',
                borderRadius: '0.5rem',
                marginTop: '1rem',
                background: 'black',
              }}
            >
              {slots.map((item, i) => (
                <div
                  key={i}
                  style={{
                    width: '4rem',
                    height: '8rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#fff',
                    color: goldText,
                    fontWeight: 'bold',
                    fontSize: '2rem',
                    border: `1px solid black`,
                    borderRadius: '0.75rem',
                    boxShadow: SLOT_BOX_SHADOW,
                    transition: 'transform 0.2s',
                    transform: spinning
                      ? 'translateZ(20px) scale(0.97)'
                      : 'translateZ(20px)',
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div
            style={{
              margin: '2.5rem auto 0 auto',
              width: '80%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <button
              style={{
                width: '100%',
                padding: '0.75rem 0',
                borderRadius: '0.5rem',
                border: `2px solid ${goldBorder}`,
                background: '#009900',
                color: spinning ? '#fffbe6' : '#191919',
                fontWeight: 700,
                fontSize: '1rem',
                letterSpacing: '0.15em',
                boxShadow: BUTTON_SHADOW,
                cursor: spinning ? 'not-allowed' : 'pointer',
                transition: 'background 0.2s, color 0.2s',
              }}
              onClick={handleButtonClick}
              disabled={spinning}
            >
              {getButtonLabel()}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookSlotMachine;
